import React from "react";
import "./practicalai.css";

const PracticalAI = ({ data }) => {
  return (
    <section className="practical-ai">
      <div className="practical-ai__container">

        {/* Heading */}
        <div className="practical-ai__heading">
          <div className="practical-ai__accent"></div>

          <div>
            {data.sectionLabel && (
              <div className="practical-ai__label">
                {data.sectionLabel}
              </div>
            )}

            <h2>{data.heading}</h2>
          </div>
        </div>

        {/* Cards */}
        <div className="practical-ai__grid">
          {data.cards.map((card) => (
            <article
              className="practical-ai__card"
              key={card.id}
            >
              <div className="practical-ai__image-wrapper">
                <img
                  src={card.image}
                  alt={card.alt || card.title}
                  className="practical-ai__image"
                />
              </div>

              <div className="practical-ai__content">
                <h3 dangerouslySetInnerHTML={{__html:card.title}}></h3>

                <p>{card.description}</p>
              </div>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PracticalAI;